import React from 'react';
import { useAppDispatch } from '../../app/hooks';
import NumberInput from '../common/NumberInput';
import { setWeaveTargetPercent, getTrainerResults } from './weaveTrainerSlice';
import { show as showWeaveInfo } from './weaveInfoSlice';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo, faLaughSquint } from '@fortawesome/free-solid-svg-icons';

function WeaveItem({
    id,
    name,
    percentStart,
    percentTarget,
    percentActual,
    pracsActual,
    percentActual2,
    pracsActual2,
    earth,
    air,
    fire,
    water,
    spirit,
    clanned,
    busy
  }: Props) {
  const dispatch = useAppDispatch();  
  
  const percentDiff = percentActual - percentActual2;
  const pracsDiff = pracsActual - pracsActual2;
  const percentClass = percentDiff > 0 ? 'positive' : (percentDiff < 0 ? 'negative' : '');
  const pracsClass = pracsDiff < 0 ? 'positive' : (pracsDiff > 0 ? 'negative' : '');
  
  let clannedClass = clanned ? 'clanned' : 'unclanned';
  if (id === 'dark_vision') {
    clannedClass = 'clanned-dark';
  }

  const weaveReqs = [
    { key: 'E', value: earth },
    { key: 'A', value: air },
    { key: 'F', value: fire },
    { key: 'W', value: water },
    { key: 'S', value: spirit }
  ].filter(x => x.value).map(x => x.value + x.key).join(' ');

  const handleNumberChange = (value: number) => {
    dispatch(setWeaveTargetPercent({ weaveId: id, percent: value }));
    dispatch(getTrainerResults());
  };

  
  const handleWeaveClick = (e: React.MouseEvent) => {
    e.preventDefault();
    dispatch(showWeaveInfo(id));
  }
  
  return (
    <div className="weave-item">
      <div className="weave-name-col">
        {id !== 'balefire' ? 
        <>
          <div className="d-flex align-items-center">
            <a tabIndex={-1} href="/#" className="weave-name" onClick={e => handleWeaveClick(e)}>{name}</a>
            {percentStart ? <div className="start-percent">*</div> : null}
          </div>
          <div className={`weave-requirements ${clannedClass}`}>{weaveReqs}</div>
        </> :
        <>
          <div className="d-flex align-items-center">
            <a tabIndex={-1} href="https://forums.wotmud.info/viewtopic.php?f=75&t=18112" className="weave-name me-1">{name}</a>
            <OverlayTrigger overlay={<Tooltip style={{position: 'fixed'}} className="balefire-tooltip"><small>Only practicable by Telanis.</small></Tooltip>}>
              <FontAwesomeIcon icon={faCircleInfo} tabIndex={0} />
            </OverlayTrigger>
          </div>
          <div className={`weave-requirements ${clannedClass}`}>?</div>
        </>
      }
      </div>
      <NumberInput
        className="weave-target" size="sm" min={0} max={99} numberValue={percentTarget || null}
        placeholder="%"
        onNumberChange={e => handleNumberChange(e ?? 0)} />
      <div className="weave-results-col">
        {busy ?
          id !== 'balefire' ?
            <div className="spinner-border spinner-border-sm text-primary me-2" role="status">
              <span className="visually-hidden">Loading...</span>
            </div> :
            <FontAwesomeIcon icon={faLaughSquint} tabIndex={0} className="me-2 text-danger rotate-animation" style={{fontSize: '1.5rem'}} />
        : null}
        
        {!busy && !percentActual ?
          <></>
        : null}

        {!busy && percentActual ?
          <>
            <div className={`weave-percentage ${percentClass}`}>{percentActual}%</div>
            <div className={`weave-practices ${pracsClass}`}>{pracsActual} prac</div>
          </>
        : null}
      </div>
    </div>
  );
}

type Props = {
  id: string;
  name: string;
  percentStart: number;
  percentTarget: number;
  percentActual: number;
  pracsActual: number;
  percentActual2: number;
  pracsActual2: number;
  earth: number;
  air: number;
  fire: number;
  water: number;
  spirit: number;
  clanned: boolean;
  busy: boolean;
};

export default React.memo(WeaveItem);
